module.exports.orResolver = params => (actions) => {
    let toResolve = () => undefined;
    actions.some((action) => {
        if (action[0]) {
            toResolve = action[1]; // eslint-disable-line
            return true;
        }
        return false;
    });
    if (typeof toResolve === 'function') {
        return toResolve(params);
    }
    return toResolve;
};

module.exports.orCondition = (...args) => {
    let result;

    args.some((action) => {
        if (action[0]) {
            result = action[1]; // eslint-disable-line
            return true;
        }
        return false;
    });
    return result;
};

module.exports.conditionalComposer = (...args) => args.reduce((acc, action) => ({
    ...acc,
    ...(action[0] ? action[1] : {}),
}), {});

module.exports.hexToRGB = (hex, alpha = 1) => {
    if (!hex) {
        return 'rgba(0,0,0,0)';
    }
    const r = parseInt(hex.slice(1, 3), 16) || 0;
    const g = parseInt(hex.slice(3, 5), 16) || 0;
    const b = parseInt(hex.slice(5, 7), 16) || 0;

    if (alpha) {
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }
    return `rgb(${r}, ${g}, ${b})`;
};

module.exports.ConditionalWrapper = ({ condition, wrapper, children }) =>
    (condition ? wrapper(children) : children);

module.exports.isEmailValid = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
};
